<template>
    <div class="wrapper" v-bind:style="styleMenu" v-show="isShown" @contextmenu.prevent>
        <b-button-group vertical class="btnGroup" size="md">
            <b-button squared variant="outline-success" class="btnIcon" @click="emitEdit()" v-if="!selectedEditable.EditMode">
                <font-awesome-icon icon="edit" class="icon"></font-awesome-icon>{{ $t('Edit') }} <!-- Editer -->
            </b-button>
            <b-button squared variant="outline-success" class="btnIcon" @click="cancelEdit" v-if="selectedEditable.EditMode">
                <font-awesome-icon icon="times" class="icon"></font-awesome-icon>{{ $t('Cancel') }} <!-- Annuler -->
            </b-button>
            <b-button squared variant="outline-success" class="btnIcon" @click="deleteVertex" v-if="selectedItem.vertex != null">
                <font-awesome-icon icon="minus" class="icon"></font-awesome-icon>{{ $t('DeleteVertex') }} <!-- Supprimer le vertex -->
            </b-button>
            <b-button squared variant="outline-success" class="btnIcon" @click="save" v-if="selectedEditable.EditMode">
                <font-awesome-icon icon="save" class="icon"></font-awesome-icon>{{ $t('Save') }} <!-- Sauvegarder -->
            </b-button>
            <b-dropdown dropright variant="outline-success" toggle-class="border-0 rounded-0 text-left" menu-class="rounded-0 menuDropDown" v-if="selectedEditable.EditMode" class="btnIcon">
                <template v-slot:button-content>
                        <font-awesome-icon icon="shapes" class="icon"></font-awesome-icon>{{ $t('Shapes') }} <!-- Formes -->
                </template>
                <b-button variant="outline-success" class="w-100 rounded-0 border-0 btnIcon" @click="handleForm('marker')"><font-awesome-icon icon="map-marker-alt" class="icon"></font-awesome-icon>{{ $t('Marker') }}</b-button>
                <b-button variant="outline-success" class="w-100 rounded-0 border-0 btnIcon" @click="handleForm('polygon')"><font-awesome-icon icon="draw-polygon" class="icon"></font-awesome-icon>{{ $t('Polygon') }}</b-button>
                <b-button variant="outline-success" class="w-100 rounded-0 border-0 btnIcon" @click="handleForm('polyline')"><font-awesome-icon icon="pen-fancy" class="icon"></font-awesome-icon>{{ $t('Polyline') }}</b-button>
            </b-dropdown>
                <b-form-input type="color" v-model="color" v-if="selectedEditable.EditMode"></b-form-input>
            <b-button squared variant="outline-success" class="btnIcon" @click="emitDelete()">
                <font-awesome-icon icon="trash-alt" class="icon"></font-awesome-icon>{{ $t('Delete') }}
            </b-button>
        </b-button-group>
    </div>

</template>

<script lang="ts">

    import { Component, Vue, Prop } from 'vue-property-decorator';
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSave, faTrashAlt, faEdit, faTimes, faMinus, faShapes, faMapMarkerAlt, faDrawPolygon, faPenFancy } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import poly from '@/types/map/type-poly';
    import locales from './locales/ContextMenu.json';

    library.add(faSave, faTrashAlt, faEdit, faTimes, faMinus, faShapes, faMapMarkerAlt, faDrawPolygon, faPenFancy);

    @Component({
        name: 'context-menu',
        components: { FontAwesomeIcon },
        i18n : { messages : locales }
    })

    export default class ContextMenu extends Vue {

        @Prop() private topClick!: string;
        @Prop() private leftClick!: string;
        @Prop() private selectedEditable!: poly;
        @Prop() private selectedEditableObject;
        @Prop() private selectedEditableIndex;
        @Prop() private selectedItem;

        isShown: boolean = true;

        get styleMenu() {
            return {
                top: this.topClick,
                left: this.leftClick
            }
        }

        get color() {
            return this.selectedEditable.Color;
        }

        set color(value) {
            this.selectedEditable.Color = value;
        }

        deleteVertex() {
            if (this.selectedEditableObject.getPath().length > 3 || this.selectedItem.vertex != undefined && this.selectedEditableObject.getPath().length > 3) {
                this.selectedEditableObject.getPath().removeAt(this.selectedItem.vertex)
            }
            this.emitClose();
        }

        hide() {
            this.isShown = !this.isShown;
        }

        save() {
            if (this.selectedEditable.Shape != "Marker") {
                this.selectedEditable.Vertex = this.selectedEditableObject.getPath().getArray();
                this.selectedEditable.Center = this.getPolyBounds(this.selectedEditable).getCenter();
            }
            else {
                this.selectedEditable.Center = this.selectedEditableObject.getPosition()
            }
            this.$emit('emitSave', { 'item': this.selectedEditable, 'indexPoly': this.selectedEditableIndex });
            this.emitEdit();
            this.emitClose();
        }

        handleForm(value: string) {
            this.$emit('emitUpdate', value);
            this.emitClose();
        }

        getPolyBounds(poly: poly) {
            let bounds = new google.maps.LatLngBounds();
            for (let point of poly.Vertex) {
                bounds.extend(point);
            }
            return bounds;
        }

        emitEdit() {
            this.$emit('emitEdit', this.selectedEditable);
            this.emitClose();
        }

        cancelEdit() {
            this.$emit('emitCancel', this.selectedEditable)
            this.emitClose();
        }

        emitDelete() {
            this.$emit('emitDelete', this.selectedEditable);
            this.emitClose();
        }

        emitClose() {
            this.$emit('emitClose')
        }
    }
</script>

<style scoped>
    .wrapper {
        position: absolute;
        z-index: 5;
    }

    .btnIcon {
        height: 40px;
        border: none;
        text-align: start;
    }

        .btnIcon .icon {
            margin-right: 10px;
        }

    .btnGroup {
        background-color: white;
    }
</style>